import { render } from "./ProductSegmentBox.vue?vue&type=template&id=9a7ac382&scoped=true"
import script from "./ProductSegmentBox.vue?vue&type=script&lang=js"
export * from "./ProductSegmentBox.vue?vue&type=script&lang=js"

import "./ProductSegmentBox.vue?vue&type=style&index=0&id=9a7ac382&lang=scss&scoped=true"

import exportComponent from "/var/www/likvio.se/html-prod/likvio-fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a7ac382"]])

export default __exports__